/* eslint-disable no-restricted-imports */
import "@gx1/gx-ui-common/styles/vars.css";
import { FeatureFlagSessionStorageProvider } from "@gx1/gx-npm-feature-flags";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { AppContextProvider } from "./app.context";
import LoginV3Component from "./sections/login-v3/login-v3.component";
import SignUpV4Component from "./sections/sign-up-v4/sign-up-v4.component";

export default function Root() {
  return (
    <FeatureFlagSessionStorageProvider apiUrl={`${window.gxApiConnection}/api/env`}>
      <AppContextProvider>
        <BrowserRouter useTransitions={false}>
          <Routes>
            <Route path="/signup" element={<SignUpV4Component />} />
            <Route path="*" element={<LoginV3Component />} />
          </Routes>
        </BrowserRouter>
      </AppContextProvider>
    </FeatureFlagSessionStorageProvider>
  );
}
